<template>
  <div class="ui-pop" v-show="false">
    <div class="ui-mask"></div>
    <div class="guidebox">
      <a class="btn-close"><i class="el-icon-close"></i></a>
      <div class="box-btn">
        <router-link to="/register" class="ui-btn">立即注册</router-link>
      </div>
      <div class="box-txt">
        <p>随时随地约课，自由选择老师</p>
        <p class="large">8折优惠课程包 <br>限时限量热销中</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="scss" scoped>
.guidebox{position: relative; width: 1000px; height: 526px; background: #fff; box-shadow: 0 12px 16px rgba($color: #000000, $alpha: .03); border-radius: 12px; display: flex; padding: 97px 50px 97px 136px; align-items: center;}
.box-btn{width: 376px; height: 332px; background:  url(../assets/guide.png); padding-top: 139px; text-align: center; margin-right: 60px;}
.box-txt{line-height: 60px; color: #002248; font-size: 18px;}
.large{font-weight: bold; font-size: 42px;}
.btn-close{
  position: absolute; width: 50px; height: 50px; line-height: 50px; text-align: center;line-height: 50px; font-size: 32px; i{font-weight: bold;} top: 47px; right: 40px;
  &:hover{opacity: .7;}
}
</style>